import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Subscription } from 'rxjs';
import { navData } from 'src/app/data/nav-data';
import { CommonService } from 'src/app/services/common.service';
import { DrilldownFormsService } from 'src/app/services/drilldown-forms.service';
import { ReportsService, ReportStaticValues } from 'src/app/services/reports.service';
import { PopupFormComponent } from '../forms/popup-form/popup-form.component';

@Component({
  selector: 'grid-see-popup-form-button',
  template: `
    <button
      mat-button
      vrm-button
      fxFlex
      [class]="customClass"
      [innerHTML]="text"
      [disabled]="!canOpenForm"
      (click)="viewForm()"
    ></button>
  `,
  styles: [
    `
      button {
        color: white;
        font-size: 12px;
        line-height: 1;
        height: 24px;
        margin-top: 3px;
      }

      .orange-button {
        background-color: orange !important;
      }

      .green-button {
        background-color: green !important;
      }
    `,
  ],
})
export class GridViewPopupFormButtonComponent implements ICellRendererAngularComp {
  private data: any;
  public text: string;
  public canOpenForm: boolean;
  public customClass: string;
  private reportsWithCustomStyles: string[] = [navData.der.id];
  private visibilitySubscription: Subscription;

  constructor(
    private cService: CommonService,
    private dfService: DrilldownFormsService,
    private dialog: MatDialog,
    private rptService: ReportsService
  ) {}

  public agInit(params: { value: string; data: any }) {
    this.text = this.cService.getSingleTranslation(`REPORTDATA.${params.value}`, params.value);
    this.data = params.data;
    this.canOpenForm = true;

    this.applyCustomStyles(params.value);
  }

  private getDERCustomClass(buttonText: string): string {
    return this.canOpenForm && buttonText === 'View'
      ? 'green-button'
      : this.canOpenForm && buttonText === 'Review'
      ? 'orange-button'
      : '';
  }

  private applyCustomStyles(buttonText: string): void {
    const navigatedReportId = this.cService.navigatedReport.navigationData.id;

    if (this.reportsWithCustomStyles.includes(navigatedReportId)) {
      this.canOpenForm = this.data.derStatus.toLowerCase() !== ReportStaticValues.reportStarted;
      this.customClass = this.getDERCustomClass(buttonText);
    }
  }

  public destroy(): void {
    this.visibilitySubscription?.unsubscribe();
  }

  public refresh(): boolean {
    return false;
  }

  public viewForm(): void {
    this.visibilitySubscription = this.dfService.formVisibility.subscribe({
      next: (isVisible) => {
        if (isVisible) {
          this.dialog.open(PopupFormComponent, {
            data: {
              showGallery: this.data.showGallery,
              galleryHasContent: this.data?.galleryHasContent,
              canCreateClaim: this.data?.canCreateClaim,
            },
            width: this.data?.showGallery ? '80%' : '600px',
          });
        }

        this.visibilitySubscription?.unsubscribe();
      },
    });

    this.dfService.selectedDriver = {
      pin: this.data.pin,
      securePin: this.rptService.currentReportMeta.information?.encryptedPin ?? false,
    };

    this.dfService.launchSelectedIntervention({
      interventionValue: this.data.coachingType,
      submissionId: this.data.submissionId,
      readOnly: this.data.readOnly,
      createdDate: this.data.createdDate ?? null,
      complete: this.data.complete ?? null,
      updatedDate: this.data.updatedDate ?? null,
    });
  }
}
